import { __assign } from "tslib";
import React from 'react';
import { Text } from '@keen.io/ui-core';
export var TooltipContent = function (_a) {
    var children = _a.children, typography = _a.typography;
    return (React.createElement(Text, __assign({}, typography), children));
};
export default TooltipContent;
